import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { logout as apiLogout } from '@/api/auth'
import { SearchInput } from './SearchInput'

export function Header({ onMenuClick }: { onMenuClick: () => void }) {
  const navigate = useNavigate()
  const admin = useAuthStore((s) => s.admin)
  const clear = useAuthStore((s) => s.clear)
  const [search, setSearch] = useState('')
  const [loggingOut, setLoggingOut] = useState(false)

  async function handleLogout() {
    if (!window.confirm('Are you sure you want to sign out?')) return
    setLoggingOut(true)
    try {
      await apiLogout()
    } finally {
      clear()
      navigate('/login')
    }
  }

  function handleSearch(value: string) {
    setSearch(value)
    if (value.trim()) navigate(`/search?q=${encodeURIComponent(value.trim())}`)
  }

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between gap-4 border-b border-slate-200/80 bg-white/95 backdrop-blur-md px-4 py-3 lg:px-7 shadow-xs">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="rounded-lg border border-slate-200 bg-slate-50 p-2 text-slate-600 hover:border-sky-300 hover:text-slate-900 lg:hidden shadow-2xs"
          aria-label="Open navigation"
        >
          ☰
        </button>

        <div className="hidden max-w-md flex-1 sm:block min-w-[280px]">
          <SearchInput
            value={search}
            onChange={handleSearch}
            placeholder="Search organizations, users, documents..."
          />
        </div>
      </div>

      <div className="ml-auto flex items-center gap-3">
        <div className="hidden text-right text-xs sm:block">
          <div className="font-bold text-slate-900">{admin?.email ?? 'admin@veloscalar.com'}</div>
          <div className="flex items-center justify-end gap-1.5 font-mono text-[10px] text-slate-500 font-semibold">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span>Active Session</span>
          </div>
        </div>

        <button
          onClick={handleLogout}
          disabled={loggingOut}
          className="group relative flex items-center gap-1.5 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 font-mono text-xs font-semibold text-slate-700 transition-all duration-150 hover:border-rose-300 hover:bg-rose-50 hover:text-rose-700 disabled:opacity-50 shadow-2xs"
        >
          <span>{loggingOut ? 'Signing out...' : 'Sign out'}</span>
          <span className="text-xs transition-transform group-hover:translate-x-0.5">→</span>
        </button>
      </div>
    </header>
  )
}
